module.exports = __webpack_public_path__ + "media/kommissar_1.2c.8879a11f.mp3";